module.exports = __webpack_public_path__ + "img/Back_button.a9e52f14.svg";